import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsDropdownModule, TooltipModule, PopoverModule } from 'ngx-bootstrap';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { DocumentsTreeModule } from '../documents-tree/documents-tree.module';
import { CandidateDocumentsComponent } from './candidate-documents.component';

@NgModule({
  declarations: [CandidateDocumentsComponent],
  imports: [
    CommonModule,
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    PipesModule,
    DocumentsTreeModule
  ],
  exports: [CandidateDocumentsComponent],
  entryComponents: [CandidateDocumentsComponent]
})
export class CandidateDocumentsModule { }
